import React from "react";
import { Link } from "react-router-dom";
import { FaInfinity, FaSyncAlt, FaRocket } from "react-icons/fa";

const FEATURES = [
  {
    icon: FaInfinity,
    title: "Acesso ilimitado",
    description: "a todos os Cadernos",
  },
  {
    icon: FaSyncAlt,
    title: "Atualizações constantes",
    description: "sempre com você",
  },
  {
    icon: FaRocket,
    title: "Novos lançamentos",
    description: "durante 12 meses",
  },
];

export default function AnnualPlanBanner() {
  return (
    <div className="annual-plan-banner">
      <Link to="/planoanual" className="annual-plan-banner-card">
        <div className="annual-plan-banner-icon-col">
          <span className="annual-plan-banner-icon-sparkle annual-plan-banner-icon-sparkle-1">
            ✦
          </span>
          <span className="annual-plan-banner-icon-sparkle annual-plan-banner-icon-sparkle-2">
            ✦
          </span>
          <div className="annual-plan-banner-icon-circle">
            <img
              src={`${process.env.PUBLIC_URL}/coroa_contorno_alta.png`}
              alt=""
              className="annual-plan-banner-icon"
            />
          </div>
        </div>

        <div className="annual-plan-banner-main">
          <span className="annual-plan-banner-badge">
            <img
              src={`${process.env.PUBLIC_URL}/coroa_contorno_alta.png`}
              alt=""
              className="annual-plan-banner-badge-icon"
            />
            PLANO ANUAL
          </span>
          <h3 className="annual-plan-banner-title">
            Conhecimento completo. Resultados reais.
          </h3>
          <p className="annual-plan-banner-text">
            Adquira as matérias avulsas abaixo, ou assine o{" "}
            <strong>Plano Anual</strong> e tenha acesso ilimitado a todas as
            matérias, atualizações e lançamentos durante{" "}
            <strong>12 meses</strong>.
          </p>
        </div>

        <div className="annual-plan-banner-divider" />

        <ul className="annual-plan-banner-features">
          {FEATURES.map(({ icon: Icon, title, description }) => (
            <li key={title} className="annual-plan-banner-feature">
              <span className="annual-plan-banner-feature-icon">
                <Icon />
              </span>
              <span className="annual-plan-banner-feature-text">
                <strong>{title}</strong>
                <span>{description}</span>
              </span>
            </li>
          ))}
        </ul>
      </Link>
    </div>
  );
}
